// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"0f1e9daa","664":"509809a7","750":"a6eeb526","945":"67a7bea8"}[chunkId] + ".chunk.css";
};